import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Controls } from './Controls';
import { useNewbuildingCountLink, useNewbuildingLinks } from './hooks';
import { trackLinkClick } from './tracking';
import { closePromoDetails } from '../../actions/promoDetails';
import { NewbuildingLinksList } from '../../components/NewbuildingLinksList';
import { PromoDetailsModal } from '../../components/PromoDetailsModal';
import { selectIsPromoDetailsOpen, selectPromoDetails, selectPromoProduct } from '../../selectors/promoDetails';
import { IPromoProduct } from '../../types/product';

export const PromoDetailsModalContainer = () => {
  const isOpen = useSelector(selectIsPromoDetailsOpen);
  const promoDetails = useSelector(selectPromoDetails);
  const promoProduct = useSelector(selectPromoProduct);
  const dispatch = useDispatch();

  const newbuildingCountLink = useNewbuildingCountLink(promoDetails);
  const newbuildingLinks = useNewbuildingLinks(promoDetails);

  const isBlackFriday = promoDetails?.promoPopupType === 'coPromos';

  const closePromoDetailsModal = React.useCallback(() => {
    dispatch(closePromoDetails());
  }, [dispatch]);

  const handleNewbuildingListingLinkClick = React.useCallback(() => {
    trackLinkClick({ isBlackFriday, product: promoProduct as IPromoProduct, type: 'to_listingjk' });
  }, [isBlackFriday, promoProduct]);

  const handleNewbuildingLinkClick = React.useCallback(() => {
    trackLinkClick({ isBlackFriday, product: promoProduct as IPromoProduct, type: 'to_jk' });
  }, [isBlackFriday, promoProduct]);

  if (!isOpen || !promoDetails) {
    return null;
  }

  return (
    <PromoDetailsModal
      onClose={closePromoDetailsModal}
      promoName={promoDetails.promoName}
      providerName={promoDetails.providerName}
      logo={promoDetails.providerLogo}
      features={promoDetails.promoProps}
      description={promoDetails.promoDescription}
      banks={promoDetails.banks}
      newbuildingLinksList={
        <NewbuildingLinksList
          newbuildingCountText={promoDetails.newbuildingCountText}
          newbuildingCountLink={newbuildingCountLink}
          newbuildingLinks={newbuildingLinks}
          onNewbuildingCountLinkClick={handleNewbuildingListingLinkClick}
          onNewbuildingLinkClick={handleNewbuildingLinkClick}
        />
      }
      linkButton={<Controls />}
    />
  );
};
